import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'curr', pure: false})
export class CurrPipe implements PipeTransform {
    transform(value: any, args: any[] = null): any {
        return Math.round(value * 100) / 100;
    }
}
